import * as React from "react";
import styled from "styled-components";
import { CustomerColors } from "../theme";
import { formatDateWithDayOfWeek } from "../utils";
import { fr as loc } from "date-fns/locale";
import { Calendar, EDays, HorizontalResourceProps } from "./Calendar";

export interface ICustomCalendarProps {
  initialEvents: any[];
  renderEvent: (e: any) => React.ReactElement;
  onDateChanged?: (StartDate: Date, EndDate: Date) => void;
  horizontalResources?: HorizontalResourceProps;
  getEventDates: (item: any) => Interval;
  createEvent?: (b1: any, b2: any) => void;
}

const Header = styled.div`
  flex: 1;
  background-color: ${CustomerColors.green};

  color: white;
  text-align: center;
  font-weight: bolder;
  padding: 0.5rem 0;
  font-size: larger;
  text-transform: uppercase;

  &.today {
    background-color: ${CustomerColors.lightGreen};
  }
`;

const HourHeader = styled.div`
  background-color: ${CustomerColors.lightGreen};
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-top: solid black 1px;
`;

export const CustomCalendar: React.FunctionComponent<ICustomCalendarProps> = ({
  initialEvents,
  renderEvent,
  onDateChanged,
  horizontalResources,
  getEventDates,
  createEvent,
}) => {
  const isWholeDay = React.useCallback((hourFrom, hourTo) => {
    return hourFrom <= 9 && hourTo >= 16;
  }, []);

  const renderDaysHeader = React.useCallback((e: Date, isToday: boolean) => {
    return (
      <Header className={isToday ? "today" : ""}>
        {formatDateWithDayOfWeek(e)}
      </Header>
    );
  }, []);

  const renderHour = React.useCallback((hour: number, height: number) => {
    return <HourHeader>{hour}</HourHeader>;
  }, []);

  const renderEmptyHeader = React.useCallback(() => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: CustomerColors.lightGreen,
        }}
      />
    );
  }, []);

  return (
    <Calendar
      isWholeDay={isWholeDay}
      daySliceInMinutes={30}
      keyColumnWidthInPx={60}
      sliceHeightInPx={25}
      scrollToHour={8}
      dateFNSLocale={loc}
      createEvent={createEvent}
      hideDays={[EDays.Sun, EDays.Sat]}
      renderEmptyHeader={renderEmptyHeader}
      renderHourHeader={renderHour}
      renderDaysHeader={renderDaysHeader}
      renderEvent={renderEvent}
      onDateChanged={onDateChanged}
      horizontalResources={horizontalResources}
      getEventDates={getEventDates}
      initialEvents={initialEvents}
      hourLimit={{ startHour: 8, endHour: 21 }}
    />
  );
};
